import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import { keyMapsMutation } from "../../helpers/storeKeys";

export default {
  namespaced: true,
  state: {
    WalletFAQData: [],
    WalletTransactions: [],
    WalletTotalBalance: 0,
    lastPageReached: false,
    currentPage: 0,
  },
  getters: {},
  mutations: {
    updateWalletFAQData(state, payload) {
      state.WalletFAQData = payload;
    },
    updateWalletTransactions(state, payload) {
      state.WalletTransactions = [...state.WalletTransactions, ...payload];
    },
    updateWalletBalance(state, payload) {
      state.WalletTotalBalance = payload;
    },
    updateLastPageReached(state, payload) {
      state.lastPageReached = payload;
    },
    updateCurrentPage(state, payload) {
      state.currentPage = payload;
    },
  },
  actions: {
    getWalletBalanceData({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .WALLET_BALANCE_API({
          headers: { ...Headers() },
        })
        .then(function (response) {
          if (response?.data?.wallet) {
            commit("updateWalletFAQData", response?.data?.wallet?.howItWorks);
            commit("updateWalletBalance", response?.data?.wallet?.totalBalance);
          }

          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
    getWalletTransactionData({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .WALLET_TRANSACTIONS_API({
          headers: { ...Headers() },
          payload,
        })
        .then(function (response) {
          if (response?.data) {
            if (response?.data?.data) {
              if (response?.data?.data.length) {
                commit("updateWalletTransactions", response?.data?.data);
                commit("updateCurrentPage", payload.pageNo);
              } else {
                commit("updateLastPageReached", true);
              }
            }
            if (response?.data?.totalBalance) {
              commit("updateWalletBalance", response?.data?.totalBalance);
            }
            commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
              root: true,
            });
          }
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
  },
};
